import { AxiosResponse } from "axios";
import axios, { APIWrapperResponse, DefaultResponse, TypedResponse } from "../general/HttpClient";
import { TournamentViewModel } from "../tournaments/TournamentsStore";
import { TeamViewModel } from "../teams/TeamsStore";
import { AliasViewModel } from "../aliases/AliasStore";

export function GetOrganizationInvite(id) {
    return axios.get(`/api/Registration/GetOrganizationInvite/${id}`).then((response: AxiosResponse<TypedResponse<OrganizationInviteViewModel>>) => {
        return response.data;
    });
}

export function GetOrganizationEntry(id) {
    return axios.get(`/api/Registration/GetOrganizationEntry/${id}`).then((response: AxiosResponse<TypedResponse<TournamentViewModel>>) => {
        return response.data;
    });
}

export function GetOrganizationInvites() {
    return axios.get(`/api/Registration/GetOrganizationInvites`).then((response: AxiosResponse<TypedResponse<OrganizationInviteViewModel[]>>) => {
        return response.data;
    });
}

export function UpdateOrganizationEntry(request: UpdateOrganizationEntryRequest) {
    return axios.put(`/api/Registration/UpdateOrganizationEntry`, request).then((response: AxiosResponse<DefaultResponse>) => {
        return response.data;
    });
}

export function CreateInvite(request: CreateOrganizationInviteRequest) {
    return axios.post(`/api/Registration/CreateInvite`, request).then((response: AxiosResponse<DefaultResponse>) => {
        return response.data;
    });
}

export function CreateEntry(request: CreateOrganizationEntryRequest) {
    return axios.post(`/api/Registration/CreateEntry`, request).then((response: AxiosResponse<DefaultResponse>) => {
        return response.data;
    });
}

export function RemoveOrganizationEntry(id) {
    return axios.delete(`/api/Registration/RemoveOrganizationEntry/${id}`).then((response: AxiosResponse<DefaultResponse>) => {
        return response.data;
    });
}

export function RemoveOrganizationInvite(id) {
    return axios.delete(`/api/Registration/RemoveOrganizationInvite/${id}`).then((response: AxiosResponse<DefaultResponse>) => {
        return response.data;
    });
}

export function UpdateOrganizationInvite(request: UpdateOrganizationInviteRequest) {
    return axios.put(`/api/Registration/UpdateOrganizationInvite`, request).then((response: AxiosResponse<DefaultResponse>) => {
        return response.data;
    });
}

export interface CreateOrganizationInviteRequest {
    organizationID: string;
    name: string;
    content: string;
    tournamentID: string;
    startDate: string;
    endDate: string;
}

export interface CreateOrganizationEntryRequest {
    inviteID: string;
    teamID: string;
    aliasIDs: string[];
}

export interface UpdateOrganizationEntryRequest {
    organizationEntryID: string;
    teamID: string;
    aliasIDs: string[];
}

export interface OrganizationInviteViewModel {
    id: string;
    organizationID: string;
    name: string;
    content: string;
    tournamentID: string;
    tournament: TournamentViewModel;
    startDate: string;
    endDate: string;
    organizationEntries: OrganizationEntryViewModel[];
}

export interface OrganizationEntryViewModel {
    id: string;
    organizationID: string;
    inviteID: string;
    teamID: string;
    team: TeamViewModel;
    participatingAliases: OrganizationEntryAliasTeamParticipantViewModel[];
}

export interface OrganizationEntryAliasTeamParticipantViewModel {
    id: string;
    organizationEntryID: string;
    aliasID: string;
    alias: AliasViewModel;
}

export interface UpdateOrganizationInviteRequest {
    organizationInviteID: string;
    name: string;
    content: string;
    startDate: string;
    endDate: string;
}
